import React, { useEffect, useState } from 'react'
import { Carousel, Container } from '../../../components'
import { useViewport } from '../../../utils'
import defaultContents from '../../../database/career-page-content.json'
import { useSelector } from 'react-redux'
import apiService from '../../../features/api/service'

const SectionBanner = () => {
  const { language } = useSelector(state => state.system)
  const { isMobile } = useViewport()
  const [contents, setContents] = useState(defaultContents)

  useEffect(() => {
    apiService.get('career_slides')
      .then(res => {
        if(res.results){
          const newContents = []

          for (let index = 0; index < res.results.length; index++) {
            const element = res.results[index];

            const {
              pkSliderLoker,
              judul,
              deskripsi,
              gambar
            } = element

            newContents.push({
              id: pkSliderLoker,
              title: {
                en: judul,
                id: judul
              },
              description: {
                en: deskripsi,
                id: deskripsi
              },
              image: gambar
            })
          }

          setContents(newContents)
        }
      })
  }, [])

  return (
    <Container className="py-10 lg:py-20 text-white" color="#52BAE2">
      {
        contents.length === 1 &&
        <div className="flex flex-wrap lg:-mx-4">
          <div className="w-full lg:w-1/2 lg:px-4 mb-8 lg:mb-0">
            <div
              className="w-full bg-no-repeat bg-center bg-cover"
              style={{minHeight: isMobile ? '200px' : '400px', backgroundImage: `url('${contents[0].image}')`}}
            ></div>
          </div>
          <div className="w-full lg:w-1/2 lg:px-4 flex items-center">
            <div className="lg:pl-16 lg:pr-12">
              <p className="text-2xl lg:text-4xl font-bold mb-4 lg:mb-8">
                {contents[0].title[language.name]}
              </p>
              <p className="lg:text-lg">
                {contents[0].description[language.name]}
              </p>
            </div>
          </div>
        </div>
      }
      {
        contents.length > 1 &&
        <Carousel className="career-slider">
          {
            contents.map(content => (
              <div className="w-full" key={content.id}>
                <div className="flex flex-wrap lg:-mx-4">
                  <div className="w-full lg:w-1/2 lg:px-4 mb-8 lg:mb-0">
                    <div
                      className="w-full bg-no-repeat bg-center bg-cover"
                      style={{minHeight: isMobile ? '200px' : '400px', backgroundImage: `url('${content.image}')`}}
                    ></div>
                  </div>
                  <div className="w-full lg:w-1/2 lg:px-4 flex items-center">
                    <div className="lg:pl-16 lg:pr-12">
                      <p className="text-2xl lg:text-4xl font-bold mb-4 lg:mb-8">
                        {content.title[language.name]}
                      </p>
                      <p className="lg:text-lg">
                        {content.description[language.name]}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </Carousel>
      }
    </Container>
  )
}

export { SectionBanner }
